<div id="domainListComp" class="users">
    <div id="domainListHeaderSec" class="data_header">
        <div id="domainLeftSec" class="left_side_section">
            <div class="mr-3">
                <div id="headerTitle" class="title">
                    <span i18n="@@domain-whitelist.domain-whitelist-title">Domain Allowlist</span>
                </div>
                <div id="domainListResult" class="results" *ngIf="displayDomainWhiteList?.length > 0">
                    <span i18n="@@domain-whitelist.page-count">Showing <strong>{{ showFrom }} - {{ showTo }}</strong> of
                        <strong>{{ paginationCount }} Allowlisted Domains</strong></span>
                </div>
            </div>
            <div id="domainSearchInput" class="input-group">
                <input #searchValue type="search" id="domainSearch" [(ngModel)]="searchData" autocomplete="off"
                    class="form-control" placeholder="{{searchPlaceholder}}"
                    (keyup.enter)="searchtheDomainsonEnter(searchData)" maxlength="75"
                    (ngModelChange)="clearSearch(searchData)" />
            </div>
            <button type="button" class="btn btn-primary ml-2 gtmUsersDomainWhitelistSearch"
                (click)="searchDomainWishlist(searchData)"></button>
        </div>
        <iposcen-spinner-overlay (getStatus)='isLoading = $event'></iposcen-spinner-overlay>
        <div id="domainListActionBtn" class="action_buttons">
            <button type="button" class="btn btn-outline-primary btn-lg gtmUsersRemoveSelected"
                [ngClass]="isDisabled ? 'default_Border': 'highlights_border'" [disabled]="isDisabled"
                (click)="removeAllSelectedDomain()">
                <span i18n="@@domain-whitelist.domain-whitelist-remove-section">Remove Selected</span>
            </button>
            <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmUsersAddDomain"
                (click)="openCreateDomainModal()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6V12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75H6C5.80109 12.75 5.61032 12.671 5.46967 12.5303C5.32902 12.3897 5.25 12.1989 5.25 12C5.25 11.8011 5.32902 11.6103 5.46967 11.4697C5.61032 11.329 5.80109 11.25 6 11.25H11.25V6C11.25 5.80109 11.329 5.61032 11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25Z"
                            fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.25 12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H18C18.1989 11.25 18.3897 11.329 18.5303 11.4697C18.671 11.6103 18.75 11.8011 18.75 12C18.75 12.1989 18.671 12.3897 18.5303 12.5303C18.3897 12.671 18.1989 12.75 18 12.75H12.75V18C12.75 18.1989 12.671 18.3897 12.5303 18.5303C12.3897 18.671 12.1989 18.75 12 18.75C11.8011 18.75 11.6103 18.671 11.4697 18.5303C11.329 18.3897 11.25 18.1989 11.25 18V12Z"
                            fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24Z"
                            fill="currentColor" />
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <rect width="24" height="24" fill="currentColor" />
                        </clipPath>
                    </defs>
                </svg>
                <span i18n="@@domain-whitelist.domain-whitelist-add-domain-name">Add Domains</span>
            </button>
        </div>
    </div>
    <hr />

    <!-- Table data -->
    <div id="domainListTableData" class="table-responsive">
        <table id="domainWhitelistTable" class="table table-borderless" aria-describedby="emailDomainList">
            <thead>
                <tr *ngIf="displayDomainWhiteList?.length > 0">
                    <th scope="col">
                        <span class="table_headings">
                            <input class="" type="checkbox" [checked]='isMasterSel' name="list_name" value=""
                                (change)="checkUncheckAll($event.target.checked)" />
                        </span>
                    </th>
                    <th scope="col" id="emailDomain">
                        <span class="table_headings" (click)="sort(email)">
                            <span i18n="@@domain-whitelist.domain-whitelist-add-domain-button-title">Email Domain</span>
                            <span class="chevron_expand"></span>
                        </span>
                    </th>
                    <th scope="col" id="createdTime">
                        <span class="table_headings" (click)="sort(createdTime)">
                            <span i18n="@@domain-whitelist.domain-whitelist-addedon">Added On</span>
                            <span class="chevron_expand"></span>
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let item of displayDomainWhiteList">
                    <tr>
                        <td>
                            <input type="checkbox" [checked]='isAllSelectedData.has(item.emailDomain)' name="list_name"
                                (change)="isAllSelected(item)" />
                        </td>
                        <td>{{item?.emailDomain}}</td>
                        <td>{{item?.createdTime | dateFormat: 'shortDateFormat'}}</td>
                        <td class="action_cell">
                            <div class="modify_record" (click)="removeItem(item)">
                                <span class="delete_record mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr class="remove_border" *ngIf="!displayDomainWhiteList?.length">
                    <td class="profile_Record"><span *ngIf='!isLoading && isDomainListTableEmpty; else loading'
                            i18n="@@retail-hq.table-body.no-records-found">No Records
                            Found</span></td>
                    <ng-template #loading>
                        <span class="text-center">{{globConst.LOADING}}</span>
                    </ng-template>
                </tr>
            </tbody>
        </table>
    </div>
    <hr />
    <!-- Pagination -->
    <div id="domainListDataFooter" class="data_footer position-relative">
        <div id="domainListPaginaiton" class="d-flex flex-column align-items-center" *ngIf="displayDomainWhiteList?.length > 0">

            <nav aria-label="domain whitelist pagination">
                <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize"
                    [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
                    (pageChange)="onTableDataChange($event)">
                </ngb-pagination>
            </nav>

            <div id="domainListPaginaitonResult" class="results mt-2">
                <span i18n="@@domain-whitelist.page-count">Showing <strong>{{ showFrom }} - {{ showTo }}</strong> of
                    <strong>{{ paginationCount }} Allowlisted Domains</strong></span>
            </div>
        </div>
    </div>
</div>

<!-- Add Domains Popup Start here -->
<div class="container" id="addDomainsPopup">
    <div class="modal-dialog-centered" *ngIf="openModalPopup">
        <div class="modal-backdrop show"></div>
        <div class="modal" id="myModal">
            <div id="addDomainModalDialog" class="modal-dialog">
                <div id="addDomainModalContent" class="modal-content" *ngIf="isAdded">
                    <div id="modalCloseIcon" class="modal_close_icons" data-dismiss="modal" (click)="CloseDomainModal()">
                    </div>
                    <div id="modalBody" class="modal-body">
                        <div id="addDomainTitle" class="heading"><span i18n="@@domain-whitelist.domain-whitelist-add-domain-name">Add
                                Domains</span></div>
                        <div id="emailDomain" class="form-group" [ngClass]="isInputFocus ? 'isFocused': 'nonFocused'">
                            <label for=""><span i18n="@@domain-whitelist.domain-whitelist-label-name">Email
                                    Domains</span><span class="astric_required">*</span></label>
                            <tag-input [(ngModel)]='domainList' class="chipe-input" [placeholder]="''"
                                [validators]="validators" [pasteSplitPattern]="splitPattern" [editable]="true"
                                [addOnPaste]="true" (onPaste)="onPaste($event)" (onBlur)="onBlurInput($event)"
                                (onFocus)="onFocusInput($event)"></tag-input>
                        </div>
                        <p id="invalidEmailDomain" class="warningText">
                            <span i18n="@@domain-whitelist.domain-whitelist-note-content">Note: Enter valid Email Domain
                                name. Example: ”iposcentral.com” or ”iposcentral.net”</span>
                        </p>
                    </div>
                    <div id="modalFooterBtn" class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-lg gtmUsersDomainWhitelistCancel"
                            data-dismiss="modal" (click)="CloseDomainModal()"><span
                                i18n="@@domain-whitelist.domain-whitelist-cancel">Cancel</span></button>
                        <button type="button" class="btn btn-primary btn-lg gtmUsersAddDomainsWhiteList"
                            [disabled]="domainList?.length == 0" (click)="submitDomainList()"> <span
                                i18n="@@domain-whitelist.domain-whitelist-add-domain-name" class="gtmUsersAddDomainsWhiteList">Add Domains</span></button>
                    </div>
                </div>

                <div id="addDomainModalContent" class="modal-content" *ngIf="!isAdded">
                    <div id="addDomainModalInvite" class="card invitePopup">
                        <div id="modalHeader" class="modal-header">
                            <div id="modalCloseIcon" class="invitesuccessmodal-close-icon" data-dismiss="modal"
                                (click)="CloseDomainModal()"></div>
                        </div>
                        <div id="addDomainModalBody" class="modal-body">
                            <div id="inviteSuccessImg" class="invitesuccess_img_div text-center">
                                <span class="invitesuccess_img"></span>
                            </div>
                            <div id="modalInviteTitle" class="invitesuccess-title text-center"><span
                                    i18n="@@domain-whitelist.domain-whitelist-added-domain-list">Domains added to
                                    allowlist</span></div>
                            <div id="modalInviteContent" class="invitesuccess-content text-center">
                                <span i18n="@@domain-whitelist.domain-whitelist-success-message">{{domainMessage}} has
                                    been successfully added to allowlist.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Add Domains Popup ends here -->

<!-- Delete Domains Popup Start here -->
<div class="container" id="addDomainsPopup">
    <div class="modal-dialog-centered" *ngIf="openDeleteModalPopup">
        <div class="modal-backdrop show"></div>
        <div class="modal" id="myModal">
            <div id="delDomainModal" class="modal-dialog">
                <div id="delDomainModalContent" class="modal-content" *ngIf="isremoved">
                    <div id="delDomainModalCloseIcon" class="modal_close_icons" data-dismiss="modal" (click)="CloseRemoveDomainModal()">
                    </div>
                    <div id="delDomainModalBody" class="modal-body">
                        <div id="removeMsg" class="heading remove_heading">
                            <span class="remove_content_text"><span
                                    i18n="@@domain-whitelist.domain-whitelist-remove-domain-items">Remove
                                    {{removeMessage}}?</span></span>
                        </div>
                        <p class="remove_text">
                            <span i18n="@@domain-whitelist.domain-whitelist-remove-text-content">This change may apply
                                to all profiles and devices using this information.</span>
                        </p>
                    </div>
                    <div id="delDomainModalFooter" class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-lg gtmUsersDomainWhitelistRemoveDomain"
                            data-dismiss="modal" (click)="CloseRemoveDomainModal()"><span
                                i18n="@@domain-whitelist.domain-whitelist-cancel">Cancel</span></button>
                        <button type="button" class="btn btn-primary btn-lg gtmUsersAddDomains"
                            (click)="removeDomainList()">{{removeTitle}}</button>
                    </div>
                </div>

                <div id="delDomainModalContent" class="modal-content" *ngIf="!isremoved">
                    <div id="cardRemovePopup" class="card removePopup">
                        <div id="removeModalHeader" class="modal-header">
                            <div class="removesuccessmodal-close-icon" data-dismiss="modal"
                                (click)="CloseRemoveDomainModal()"></div>
                        </div>
                        <div class="modal-body">
                            <div id="removeSuccessImg" class="removesuccess_img_div text-center">
                                <span class="removesuccess_img"></span>
                            </div>
                            <div id="removeSuccessTitle" class="removesuccess-title text-center"><span
                                    i18n="@@domain-whitelist.domain-whitelist-remove-domain-total-list">{{removeMessage}}
                                    Removed</span></div>
                            <div id="removeSuccessMsg" class="removesuccess-content text-center">
                                <span
                                    i18n="@@domain-whitelist.domain-whitelist-removed-success-message">{{removedSuccessMessage}}
                                    has been successfully removed from allowlist.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Delete Domains Popup ends here -->